define("analytics/routes", ["exports", "ember-engines/routes"], function (_exports, _routes) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-engines/routes"eaimeta@70e063a35619d71f
  var _default = _exports.default = (0, _routes.default)(function () {
    this.route('profile', {
      path: '/:slug'
    }, function () {
      this.route('instagram', function () {
        this.route('overview', function () {
          this.route('lifespan', {
            path: 'lifespan/:media_item'
          });
        });
        this.route('audience');
        this.route('posts', function () {
          this.route('lifespan', {
            path: 'lifespan/:media_item'
          });
        });
        this.route('reels', function () {
          this.route('lifespan', {
            path: 'lifespan/:media_item'
          });
        });
        this.route('stories', function () {
          this.route('lifespan', {
            path: 'lifespan/:media_item'
          });
        });
        this.route('hashtags', function () {
          this.route('details', {
            path: '/:hashtag'
          }, function () {
            this.route('index', {
              path: '/details'
            });
            this.route('lifespan', {
              path: 'lifespan/:media_item'
            });
          });
        });
        this.route('linkinbio');
      });
      this.route('facebook', function () {
        this.route('overview', function () {
          this.route('lifespan', {
            path: 'lifespan/:media_item'
          });
        });
        this.route('posts', function () {
          this.route('lifespan', {
            path: 'lifespan/:media_item'
          });
        });
      });
      this.route('linkinbio', function () {
        this.route('overview');
      });
      this.route('pinterest', function () {
        this.route('overview', function () {
          this.route('lifespan', {
            path: 'lifespan/:pin'
          });
        });
        this.route('pins', function () {
          this.route('lifespan', {
            path: 'lifespan/:pin'
          });
        });
      });
      this.route('twitter', function () {
        this.route('overview', function () {
          this.route('lifespan', {
            path: 'lifespan/:media_item'
          });
        });
        this.route('tweets', function () {
          this.route('lifespan', {
            path: 'lifespan/:media_item'
          });
        });
      });
      this.route('tiktok', function () {
        this.route('overview', function () {
          this.route('lifespan', {
            path: 'lifespan/:media_item'
          });
        });
        this.route('audience');
        this.route('posts', function () {
          this.route('lifespan', {
            path: 'lifespan/:media_item'
          });
        });
        this.route('linkinbio');
      });
      this.route('threads', function () {
        this.route('overview', function () {
          this.route('lifespan', {
            path: 'lifespan/:media_item'
          });
        });
        this.route('audience');
        this.route('posts', function () {
          this.route('lifespan', {
            path: 'lifespan/:media_item'
          });
        });
      });
      this.route('linkedin', function () {
        this.route('overview', function () {
          this.route('lifespan', {
            path: 'lifespan/:media_item'
          });
        });
        this.route('posts', function () {
          this.route('lifespan', {
            path: 'lifespan/:media_item'
          });
        });
      });
    });
    this.route('restricted');
  });
});